<template>
  <div class="card filemanager-sidebar me-md-2 partner-side-menu" ref="parentList" style="background-color: #888888;">
    <div class="card-body">
      <div class="d-flex flex-column">
        <div>
          <ul class="list-unstyled categories-list">
            <li>
              <div class="custom-accordion">
                <div class="card border-0 shadow-none mb-0" style="background-color: #6F6954FF; color: #ffffff;">
                  <ul class="list-unstyled mb-0">
                    <li>
                      <a href="javascript: void(0)" @click="getPartners(null)" class="d-flex align-items-center">
                        <span class="badge badge-pill badge-soft-info me-1" style="background-color: #222222; color:gold;" v-if="selectedPartner === null">선택</span>
                        <partner-badge :partner="$store.getters['auth/user']"></partner-badge>
                        <span class="me-auto" style="color:#ffffff;">{{ $store.getters['auth/user'].username }}</span>
                      </a>
                      <ul class="list-unstyled mb-0">
                        <li v-for="top in partners" :key="'partner-' + top.id">
                          <a href="javascript: void(0)" @click="getPartners(top)" class="d-flex align-items-center">
                            <span class="badge badge-pill badge-soft-info me-1" style="background-color: #222222; color:gold;" v-if="selectedPartner && selectedPartner.id === top.id">선택</span>
                            <partner-badge :partner="top"></partner-badge>
                            <span class="me-auto" style="color:#ffffff;">{{ top.username }}<template v-if="top.username === 'uniontop'"> (테스트)</template></span>
                          </a>
                          <ul class="list-unstyled mb-0">
                            <li v-for="superA in top.children" :key="'child-' + superA.id">
                              <a href="javascript: void(0)" @click="getPartners(superA)" class="d-flex align-items-center">
                                <span class="badge badge-pill badge-soft-info me-1" style="background-color: #222222; color:gold;" v-if="selectedPartner && selectedPartner.id === superA.id">선택</span>
                                <partner-badge :partner="superA"></partner-badge>
                                <span class="me-auto" style="color:#ffffff;">{{ superA.username }}</span>
                              </a>
                              <ul class="list-unstyled mb-0">
                                <li v-for="master in superA.children" :key="'child-' + master.id">
                                  <a href="javascript: void(0)" @click="getPartners(master)" class="d-flex align-items-center">
                                    <span class="badge badge-pill badge-soft-info me-1" style="background-color: #222222; color:gold;" v-if="selectedPartner && selectedPartner.id === master.id">선택</span>
                                    <partner-badge :partner="master"></partner-badge>
                                    <span class="me-auto" style="color:#ffffff;">{{ master.username }}</span>
                                  </a>
                                  <ul class="list-unstyled mb-0">
                                    <li v-for="agent in master.children" :key="'child-' + agent.id">
                                      <a href="javascript: void(0)" @click="getPartners(agent)" class="d-flex align-items-center">
                                        <span class="badge badge-pill badge-soft-info me-1" style="background-color: #222222; color:gold;" v-if="selectedPartner && selectedPartner.id === agent.id">선택</span>
                                        <partner-badge :partner="agent"></partner-badge>
                                        <span class="me-auto" style="color:#ffffff;">{{ agent.username }}</span>
                                      </a>
                                      <ul class="list-unstyled mb-0">
                                        <li v-for="shop in agent.children" :key="'child-' + shop.id">
                                          <a href="javascript: void(0)" @click="getPartners(shop)" class="d-flex align-items-center">
                                            <span class="badge badge-pill badge-soft-info me-1" style="background-color: #222222; color:gold;" v-if="selectedPartner && selectedPartner.id === shop.id">선택</span>
                                            <partner-badge :partner="shop"></partner-badge>
                                            <span class="me-auto" style="color:#ffffff;">{{ shop.username }}</span>
                                          </a>
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .filemanager-sidebar {
    /*
    min-width: 30px;
    max-width: 30px;
     */
  }
</style>

<script>
import PartnerBadge from '../badge-level'

export default {
  components: {
    PartnerBadge
  },
  props: {
    partner: { type: Object, default: null }
  },
  data: function () {
    return {
      partners: [],
      selectedPartner: null,
      userCount: 0,
      partnerCount: 0
    }
  },
  mounted() {
    this.getMyCount()
  },
  methods: {
    getMyCount: async function() {
      const result = await this.$API.partner.countChildren()
      if (result.code !== 0) {
        return alert(result.msg)
      }
      this.userCount = result.userCount
      this.partnerCount = result.partnerCount
    },
    getPartners: async function(parent) {
      if (parent) {
        this.selectedPartner = parent
        this.$emit('setParent', parent.id)
      } else {
        this.selectedPartner = null
        this.$emit('setParent', null)
      }

      this.$emit('searchList')

      const loader = this.$loading.show({ container: this.$refs.parentList })
      try {
        const result = await this.$API.partner.children(parent ? parent.id : null)
        if (result.code !== 0) {
          return alert(result.msg)
        }
        if (parent) {
          for(const key in result.documents) {
            const partner = result.documents[key]
            let find = false
            for(const key1 in parent.children) {
              const child = parent.children[key1]
              if (child.id === partner.id) {
                child.partnerCount = partner.partnerCount
                find = true
                break
              }
            }
            if (find === false) {
              partner.children = []
              parent.children.push(partner)
            }
          }
        } else {
          for(const key in result.documents) {
            const partner = result.documents[key]
            let find = false
            for (const key1 in this.partners) {
              const child = this.partners[key1]
              if (child.id === partner.id) {
                child.partnerCount = partner.partnerCount
                find = true
                break
              }
            }
            if (find === false) {
              partner.children = []
              this.partners.push(partner)
            }
          }
        }
      } catch(e) {
        this.$log.error(e)
      } finally {
        loader.hide()
      }
    },
  }
}
</script>
